/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S6_TitleInputs */

const en_guide_json_rest_api_s6_title = /** @type {(inputs: Guide_Json_Rest_Api_S6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Designing JSON responses that age well`)
};

const ko_guide_json_rest_api_s6_title = /** @type {(inputs: Guide_Json_Rest_Api_S6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오래가는 JSON 응답 설계`)
};

const ja_guide_json_rest_api_s6_title = /** @type {(inputs: Guide_Json_Rest_Api_S6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`長く使える JSON レスポンスの設計`)
};

/**
* | output |
* | --- |
* | "Designing JSON responses that age well" |
*
* @param {Guide_Json_Rest_Api_S6_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s6_title = /** @type {((inputs?: Guide_Json_Rest_Api_S6_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S6_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s6_title(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s6_title(inputs)
	return ja_guide_json_rest_api_s6_title(inputs)
});